import config from "../config";
import { getActions, getType, getTypes } from "../helpers/crudActions";
import HttpClient from "../helpers/httpclient";

const TOGGLE_HAVERSTING_LOSS = getType("TOGGLE_HAVERSTING_LOSS", "SHARED_OBJECTS");
export const TOGGLE_HAVERSTING_LOSS_FULFILLED = getType("TOGGLE_HAVERSTING_LOSS_FULFILLED", "SHARED_OBJECTS");
const TOGGLE_AUTO_MMF = getType("TOGGLE_AUTO_MMF", "ACCOUNT");
export const TOGGLE_AUTO_MMF_FULFILLED = getType("TOGGLE_AUTO_MMF_FULFILLED", "ACCOUNT");

export default {
  ...getActions("ACCOUNT_ARS", "account-ars"),
  ...getTypes("ACCOUNT_ARS"),
  updateAutomatedInvesting(id, enabled, updateList = false) {
    return {
      type: getType("OBJECT_TOGGLE_STATUS", "ACCOUNT_ARS"),
      payload: HttpClient.put(`${config.api}/account-ars/${id}/toggle-active`, { automated_investing: enabled }),
      meta: { updateList },
    };
  },
  listImplement(page = 1, status = "active", term = null, sort = null, proposalVersion) {
    return this.listWith(page, status, term, sort, { proposalVersion, implement: true });
  },
  updateHarvestingLoss(id, value, updateList = false) {
    return {
      type: TOGGLE_HAVERSTING_LOSS,
      payload: HttpClient.put(`${config.api}/account-ars/${id}/toggle-harvesting-loss`, { tax_loss: value }),
      meta: { updateList },
    };
  },
  updateAutoMmf(id, enabled, updateList = false) {
    return {
      type: TOGGLE_AUTO_MMF,
      payload: HttpClient.put(`${config.api}/account-ars/${id}/toggle-auto-mmf`, { automated_mmf: enabled }),
      meta: { updateList },
    };
  },
};
